

export default function MenuPartitionDelimiter({name}) {
    return <p className="project-node-menu-delimiter">{name}</p>;
}
